export default "__VITE_ASSET__CBCyjyIt__"